import { IStorePlaceGetDTO, IStorePlaceViewDTO } from "../../libs/coreapi-dto/dirs/storePlace";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class StorePlaceDataProvider extends DictionaryDataProvider<IStorePlaceViewDTO, IStorePlaceGetDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IStorePlaceViewDTO, IStorePlaceGetDTO>> {
        return this._coreApiService.storePlaceRequest
    }
}